import navigateToNextHairstyleOnboardingPageAction from "@actions/navigateToNextHairstyleOnboardingPageAction"
import hairstyleOnboardingLoader from "@loaders/hairstyleOnboardingLoader"
import { Navigate, Outlet } from "react-router-dom"
import AgePage from "../AgePage"
import CompanyPage from "../CompanyPage"
import ComplimentPage from "../ComplimentPage"
import ConfidenceBoostPage from "../ConfidenceBoostPage"
import FirstImpressionPage from "../FirstImpressionPage"
import GenderPage from "../GenderPage"
import HairstyleFrequencyPage from "../HairstyleFrequencyPage"
import PersonalityPage from "../PersonalityPage"
import PhotoUsagePage from "../PhotoUsagePage"
import SharePhotoPage from "../SharePhotoPage"
import SubscriptionCountPage from "../SubscriptionCountPage"
import TryFirstSubPage from "../TryFirstSubPage"
import HairstyleAlmostTherePage from "./HairstyleAlmostTherePage"
import HairstyleBoldLooksPage from "./HairstyleBoldLooksPage"
import HairstyleDoingAmazingPage from "./HairstyleDoingAmazingPage"
import HairstyleExperimentingLookPage from "./HairstyleExperimentingLookPage"
import HairstyleFutureLookPage from "./HairstyleFutureLookPage"
import HairstyleReadyToTransformPage from "./HairstyleReadyToTransformPage"
import HairstyleStyleFeelingPage from "./HairstyleStyleFeelingPage"
import HairstyleStyleProfilePage from "./HairstyleStyleProfilePage"
import HairstyleUnleashLookPage from "./HairstyleUnleashLookPage"

const action = navigateToNextHairstyleOnboardingPageAction

const onboardingHairstyleRoutes = [
  {
    path: "/onboarding/hairstyle",
    element: <Outlet />,
    loader: hairstyleOnboardingLoader,
    children: [
      {
        element: <Navigate to={`gender${window.location.search}`} replace />,
        index: true,
      },
      { action, element: <GenderPage />, path: "gender" },
      { action, element: <AgePage />, path: "age" },
      { action, element: <CompanyPage />, path: "company" },
      { action, element: <HairstyleUnleashLookPage />, path: "unleashLook" },
      { action, element: <FirstImpressionPage />, path: "firstImpression" },
      { action, element: <TryFirstSubPage />, path: "tryFirstSub" },
      {
        action,
        element: <HairstyleStyleFeelingPage />,
        path: "styleFeeling",
      },
      {
        action,
        element: <HairstyleFrequencyPage />,
        path: "hairstyleFrequency",
      },
      { action, element: <HairstyleBoldLooksPage />, path: "boldLooks" },
      { action, element: <SharePhotoPage />, path: "sharePhoto" },
      {
        action,
        element: <HairstyleExperimentingLookPage />,
        path: "experimentingLook",
      },
      { action, element: <HairstyleDoingAmazingPage />, path: "doingAmazing" },
      { action, element: <ConfidenceBoostPage />, path: "confidenceBoost" },
      { action, element: <HairstyleFutureLookPage />, path: "futureLook" },
      { action, element: <PersonalityPage />, path: "personality" },
      { action, element: <ComplimentPage />, path: "compliment" },
      {
        action,
        element: <HairstyleStyleProfilePage />,
        path: "styleProfile",
      },
      {
        action,
        element: <HairstyleReadyToTransformPage />,
        path: "readyToTransform",
      },
      { action, element: <PhotoUsagePage />, path: "photoUsage" },
      {
        action,
        element: <SubscriptionCountPage />,
        path: "subscriptionCount",
      },
      { action, element: <HairstyleAlmostTherePage />, path: "almostThere" },
    ],
  },
]

export default onboardingHairstyleRoutes
